import { IQuotationScheduleVO } from '../quotation/quotation-schedule.model';
import { IRevisionModel } from '../revision/revision.model';
import { IServicesModel } from './service-model/services.model';

export interface IScheduledServices {
  scheduleId: number;
  bookingId: string;
  divisionId: number;
  country: string | null;
  dealerId: number;
  dealerName: string;
  dealerAddress: string;
  dealerLat: number;
  dealerLng: number;
  advisorId: number;
  advisorName: string;
  scheduleDate: string;
  scheduleHour: number;
  vehiclePlate: string;
  vehicleModel: string;
  vehicleModelYear: number;
  vin: string;
  revision: boolean;
  pickupDelivery: boolean;
  customerRemarks: string;
  remark: string;
  revisionItems: IRevisionModel;
  services: IServicesModel[];
  quotation: IQuotationScheduleVO;
  campaignsIds: number[];
  scheduleModality: string;
  winchService: boolean;
  labourCost: string;
  pickUpHour: any;
  pickUpDateTime: any;
  pickUpDate: any;
  formattedDate: {
    weekday: string,
    date: string
  };
}
